import React, { Component, Fragment } from 'react'
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import Loader from "../loader";
import Hero from "../components/hero";
import Bar from "../components/bar";
import FixedBar from "../components/fixed-bar";
import DateCounter from "../components/date-counter";
import CustomSection from "../components/custom-section";
import ModalDon from "../components/modal-don";
import TeamProgress from "../components/team-progress";
import TeamDonSection from "../components/team-don-section";
import DonSection from "../components/don-section";
import BarCount from "../components/bar-count";
import TeamProgressCount from "../components/team-progress-count";
import { ASSET_URL } from "../../../config";
import Products from "../components/products";
import BarPartner from "../components/bar-partner";
import RenderConfetti from "../components/confetti";
import { t } from "@lingui/core/macro";
import TeamProgressPartner from "../components/team-progress-partner";
import TeamBackBanner from "../components/team-back-banner";
import DeviseChoiceModal from "../components/devise-choice";

export default class Home extends Component {

    modalDon = null
    showModalDon = (_defaultSelectedProducts = []) => {
        this.modalDon.show(_defaultSelectedProducts)
    }

    render() {
        const DEFAULT_SECTIONS = [
            { id: "DATECOUNTER", type: "DATECOUNTER", label: t`Compteur`, editable: false, hidden: false },
            { id: "TEAMPROGRESS", type: "TEAMPROGRESS", label: t`Progression de l'équipe`, editable: false, hidden: false },
            { id: "PRODUCTS", type: "PRODUCTS", label: t`Produits`, editable: false, hidden: false },
            { id: "DONORS", type: "DONORS", label: t`Donateurs`, editable: false, hidden: false },
        ]

        let context = { ...this.props.context, actions: { showModalDon: this.showModalDon } }

        const { org, config } = context

        const { isMobile } = context

        const { campagneData, campagneTarget } = this.props

        const campagneDataConfig = campagneData?.config || {}

        const sections = campagneData?.config["sections"] || DEFAULT_SECTIONS

        const title = campagneDataConfig.metaTitle || campagneData.label
        const description = campagneDataConfig.metaDescription || null
        const image = campagneDataConfig.metaImage
        const video = campagneDataConfig.metaVideo

        const hideBar = campagneData?.config?.hideBar || false


        if (this.props.loading) {
            return (
                <div>
                    <Meta seo={campagneDataConfig} context={context} title={title} description={description} image={image} video={video} />
                    <Loader />
                </div>
            )
        }

        return (
            <div className={"campagne-page"}>
                <Meta seo={campagneDataConfig} context={context} title={title} description={description} image={image} video={video} />
                <Header context={context} campagneData={campagneData} />
                <TeamBackBanner context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                <Hero context={context} campagneData={campagneData} campagneTarget={campagneTarget} />

                {!hideBar && campagneData.type === "PARTNER" && (
                    <BarPartner context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                )}

                {!hideBar && campagneData.type === "COUNT" && (
                    <BarCount context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                )}

                {!hideBar && !campagneData.type && (
                    <Bar context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                )}

                <div>
                    {sections.map(s => {
                        if (s.hidden) {
                            return null
                        }

                        switch (s.type) {
                            case "DATECOUNTER":
                                let _counterTitle = t`temps restant avant la fin de la campagne`
                                let _dateCounter = campagneData.dateEnd
                                if (new Date() < new Date(campagneData.dateStart)) {
                                    _counterTitle = t`temps restant avant le début de la campagne`
                                    _dateCounter = campagneData.dateStart
                                }

                                if (new Date() > new Date(_dateCounter)) {
                                    return null
                                }

                                return (
                                    <DateCounter key={s.id} datetime={_dateCounter} title={_counterTitle} />
                                )
                                break;

                            case "PRODUCTS":
                                if (campagneData?.config?.noModal) {
                                    return (
                                        <ModalDon noModal context={context} campagneData={campagneData} campagneTarget={campagneTarget} getRef={(ref) => { }} />
                                    )
                                }

                                return (
                                    <div key={s.id} style={{ marginBottom: 10 }}>
                                        <Products context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                    </div>
                                )
                                break;

                            case "SECTION":
                                return (
                                    <CustomSection key={s.id} id={s.id} section={s} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                )
                                break;

                            case "TEAMPROGRESS":
                                if (campagneData.type === "COUNT") {
                                    return <TeamProgressCount key={s.id} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                }
                                if (campagneData.type === "PARTNER") {
                                    return <TeamProgressPartner key={s.id} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                }
                                return <TeamProgress key={s.id} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                break;

                            case "DONORS":
                                if (campagneTarget?.initial?.team) {
                                    return (
                                        <div className={"container"} style={{ marginBottom: "2rem",marginTop: "2rem" }}>
                                            <DonSection key={s.id} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                        </div>
                                    )
                                }

                                return (
                                    <TeamDonSection key={s.id} context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                                )
                                break;
                        }
                    })}
                </div>

                <Footer context={context} campagneData={campagneData} campagneTarget={campagneTarget} />

                {campagneData?.config?.forceCelebration && (
                    <RenderConfetti />
                )}

                {!campagneData?.gala && (
                    <FixedBar context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
                )}

                <ModalDon context={context} campagneData={campagneData} campagneTarget={campagneTarget} getRef={(ref) => this.modalDon = ref} />
                <DeviseChoiceModal context={context} campagneData={campagneData} />
            </div>
        )
    }
}
